import React from 'react';
import PublicLayout from '../../components/layouts/PublicLayout';
import Card from '../../components/common/Card';
import { theme } from '../../config/theme';
import { FaRocket, FaShieldAlt, FaStore, FaUsers } from 'react-icons/fa';

const About = () => {
  const pageTitleStyles = {
    fontSize: 'clamp(2rem, 4vw, 2.75rem)',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.white,
    margin: 0,
  };

  const heroSubtitleStyles = {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: theme.typography.fontSize.lg,
    margin: 0,
    maxWidth: 760,
    lineHeight: 1.6,
  };

  const heroStyles = {
    background: `linear-gradient(135deg, ${theme.colors.primary.main} 0%, ${theme.colors.primary.dark} 100%)`,
    borderRadius: theme.borderRadius['2xl'] || '1rem',
    padding: `${theme.spacing['4xl'] || '4rem'} ${theme.spacing['2xl'] || '2rem'}`,
    color: theme.colors.white,
    boxShadow: theme.shadows.lg,
    overflow: 'hidden',
  };

  const sectionHeadingStyles = {
    fontSize: theme.typography.fontSize['2xl'],
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.text.primary,
    margin: 0,
  };

  const sectionTextStyles = {
    color: theme.colors.text.secondary,
    lineHeight: 1.8,
    margin: 0,
    fontSize: theme.typography.fontSize.base,
  };

  const featureIconWrapStyles = {
    width: 44,
    height: 44,
    borderRadius: theme.borderRadius.lg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: `${theme.colors.primary.main}15`,
    color: theme.colors.primary.main,
    marginBottom: theme.spacing.md,
  };

  return (
    <PublicLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: 1100, margin: '0 auto' }}>
        <div style={heroStyles}>
          <h1 style={pageTitleStyles}>About Us</h1>
          <p style={heroSubtitleStyles}>
            We’re building a multi-vendor shopping experience designed to be fast, trustworthy, and
            rewarding for both customers and sellers.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: theme.spacing.xl, marginTop: theme.spacing.xl }}>
          <Card padding="xl">
            <h2 style={sectionHeadingStyles}>Our Story</h2>
            <p style={{ ...sectionTextStyles, marginTop: theme.spacing.md }}>
              AlarcTrade brings together independent sellers and customers on one platform. Our
              goal is to make browsing, buying, and selling feel simple and reliable—whether you’re
              discovering your next favorite product or growing your store.
            </p>
          </Card>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: theme.spacing.xl }}>
            <Card padding="xl">
              <div style={featureIconWrapStyles}>
                <FaRocket size={20} />
              </div>
              <h3 style={{ margin: 0, fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.bold }}>
                Mission
              </h3>
              <p style={{ ...sectionTextStyles, marginTop: theme.spacing.sm }}>
                Deliver a smooth marketplace experience with clear product discovery and checkout.
              </p>
            </Card>

            <Card padding="xl">
              <div style={featureIconWrapStyles}>
                <FaShieldAlt size={20} />
              </div>
              <h3 style={{ margin: 0, fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.bold }}>
                Trust & Safety
              </h3>
              <p style={{ ...sectionTextStyles, marginTop: theme.spacing.sm }}>
                Built-in validation, role-based access, and protected routes to keep things secure.
              </p>
            </Card>

            <Card padding="xl">
              <div style={featureIconWrapStyles}>
                <FaUsers size={20} />
              </div>
              <h3 style={{ margin: 0, fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.bold }}>
                Customer First
              </h3>
              <p style={{ ...sectionTextStyles, marginTop: theme.spacing.sm }}>
                Search, filters, wishlists, and order tracking that help you move quickly.
              </p>
            </Card>

            <Card padding="xl">
              <div style={featureIconWrapStyles}>
                <FaStore size={20} />
              </div>
              <h3 style={{ margin: 0, fontSize: theme.typography.fontSize.lg, fontWeight: theme.typography.fontWeight.bold }}>
                Seller Tools
              </h3>
              <p style={{ ...sectionTextStyles, marginTop: theme.spacing.sm }}>
                Manage products, onboarding, subscriptions, and sales analytics in one place.
              </p>
            </Card>
          </div>

          <Card padding="xl">
            <h2 style={sectionHeadingStyles}>Why We Exist</h2>
            <p style={{ ...sectionTextStyles, marginTop: theme.spacing.md }}>
              Ecommerce/trade should feel effortless. Our platform connects talented sellers with customers who
              want quality, transparency, and great service—every step of the way.
            </p>
          </Card>
        </div>
      </div>
    </PublicLayout>
  );
};

export default About;

